import {
  NBS_API_CANCEL_WEB_SUBSCRIPTION_REQUEST,
  NBS_API_CANCEL_WEB_SUBSCRIPTION_SUCCESS,
  NBS_API_CANCEL_WEB_SUBSCRIPTION_FAILURE,
  NBS_API_CANCEL_WEB_SUBSCRIPTION_RESET_DATA,
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_CANCEL_WEB_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request',
      };
    case NBS_API_CANCEL_WEB_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success',
      };
    case NBS_API_CANCEL_WEB_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail',
      };
    case NBS_API_CANCEL_WEB_SUBSCRIPTION_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
